/*
 * @Author: your name
 * @Date: 2021-05-04 13:36:12
 * @LastEditTime: 2023-06-30 18:11:35
 * @LastEditors: zhangzhian
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\routes\modules\recruitment.js
 */
export default [
  {
    name: "recruitmentPosition",
    path: "/recruitment/position",
    component: () => import("@/views/recruitment/position/index.vue"),
    meta: {
      title: "内推岗位",
    },
  },
  {
    name: "recruitmentCandidate",
    path: "/recruitment/candidate",
    component: () => import("@/views/recruitment/candidate/index.vue"),
    meta: {
      title: "内推候选人",
    },
  },
  {
    name: "recruitmentSourcingRecord",
    path: "/recruitment/sourcingRecord",
    component: () => import("@/views/recruitment/sourcingRecord/index.vue"),
    meta: {
      title: "寻聘记录报表",
      replaceSameTab: true,
    },
  },
  {
    name: "recruitmentTalentAiReport",
    path: "/recruitment/talentAiReport",
    component: () => import("@/views/recruitment/talentAiReport/index.vue"),
    meta: { title: "AI评估报告", replaceSameTab: true },
  },
  {
    name: "recruitmentTalentAiReportDetail",
    path: "/recruitment/talentAiReport/:reportId",
    component: () => import("@/views/recruitment/talentAiReport/detail.vue"),
    // 多职位报告切换时复用当前后台页签，避免每个职位重复打开详情页签。
    meta: { title: "AI评估报告详情", parentAuth: "/recruitment/talentAiReport", replaceSameTab: true },
    props: true,
  },
  {
    name: 'campusRecruitmentPosition',
    path: '/recruitment/campusPosition',
    component: () => import('@/views/recruitment/campus/position/index.vue'),
    meta: {
      title: '校招岗位'
    }
  },
  {
    name: 'campusRecruitmentCandidate',
    path: '/recruitment/campusCandidate',
    component: () => import('@/views/recruitment/campus/candidate/index.vue'),
    meta: {
      title: '校招候选人'
    }
  },
  {
    name: 'campusRecruitmentCandidateDetail',
    path: '/recruitment/campusCandidateDetail/:id',
    component: () => import('@/views/recruitment/candidateFormal/detail/index'),
    meta: {
      title: route => {
        const name = decodeURIComponent(route.query.name || '');
        return `候选人${name}详情`;
      },
      parentAuth: '/recruitment/campusCandidate'
    },
    props: route => ({
      ...route.params,
      ...route.query
    })
  },
  {
    name: "recruitmentPoint",
    path: "/recruitment/point",
    component: () => import("@/views/recruitment/pointsDetails/index.vue"),
    meta: {
      title: "积分管理",
    },
  },
  {
    name: "recruitmentActivity",
    path: "/recruitment/activity",
    component: () => import("@/views/recruitment/activity/index.vue"),
    meta: {
      title: "内推活动",
    },
  },
  {
    name: "recruit-demand-box",
    path: "/recruitment/recruitDemand",
    component: () => import("@/views/recruitment/recruitDemand/index.vue"),
    meta: {
      title: "招聘需求报表",
      replaceSameTab: true,
    },
  },
  {
    name: "offerManagement",
    path: "/recruitment/offerManagement",
    component: () => import("@/views/recruitment/offerManagement/index.vue"),
    meta: {
      title: "Offer审批",
    },
  },
  {
    name: "offerStateManagement",
    path: "/recruitment/offerStateManagement",
    component: () =>
      import("@/views/recruitment/offerManagement/stateIndex.vue"),
    meta: {
      title: "预入职管理",
      replaceSameTab: true,
    },
  },
  {
    name: "offerIndex",
    path: "/recruitment/offerIndex",
    component: () =>
      import("@/views/recruitment/offerManagement/offerIndex.vue"),
    meta: {
      title: "Offer管理",
    },
  },
  {
    name: "entryApprove",
    path: "/recruitment/entryApproval/:mobile",
    component: () =>
      import(
        "@/views/recruitment/offerManagement/components/entryApproval/index.vue"
      ),
    meta: {
      parentAuth: "/recruitment/offerStateManagement",
      title: "预入职管理",
    },
  },
  {
    name: "backgroundInvestigation",
    path: "/recruitment/backgroundInvestigation",
    component: () =>
      import("@/views/recruitment/backgroundInvestigation/index.vue"),
    meta: {
      title: "背景调查",
    },
  },
  {
    name: "candidateFormal",
    path: "/recruitment/candidateFormal",
    component: () => import("@/views/recruitment/candidateFormal/list/index"),
    meta: {
      title: "候选人",
      replaceSameTab: true,
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: "candidateDetail",
    path: "/recruitment/candidateDetail/:id", // 这个id为招聘id，字段名是 resumeId 或是 applicantId。注意不是列表中的id
    component: () => import("@/views/recruitment/candidateFormal/detail/index"),
    meta: {
      title: (route) => {
        const name = decodeURIComponent(route.query.name || "");
        return `候选人${name}详情`;
      },
      parentAuth: "/recruitment/candidateFormal",
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: "recruitmentJobTitle",
    path: "/recruitment/jobTitle",
    component: () => import("@/views/recruitment/recruitmentJobTitle/index"),
    meta: {
      title: "招聘职位",
      replaceSameTab: true,
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: "recruitmentJobTitleDetail",
    path: "/recruitment/jobTitleDetail/:id",
    component: () =>
      import("@/views/recruitment/recruitmentJobTitle/detail/index.vue"),
    meta: {
      title: "招聘职位详情",
      parentAuth: "/recruitment/jobTitle",
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: "advertisingList",
    path: "/recruitment/advertisingList",
    component: () => import("@/views/recruitment/advertisingList/index"),
    meta: {
      title: "广告列表",
      parentAuth: "/recruitment/jobTitle",
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: "satisfactionEvaluation",
    path: "/recruitment/satisfactionEvaluation",
    component: () => import("@/views/recruitment/satisfactionEvaluation/index"),
    meta: {
      title: "面试满意度评价表",
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: "bannerSetting",
    path: "/recruitment/bannerSetting",
    component: () => import("@/views/recruitment/banner/index.vue"),
    meta: {
      title: "banner管理",
    },
  },
  {
    name: "recruitmentHome",
    path: "/recruitment/home",
    component: () => import("@/views/recruitment/home/index.vue"),
    meta: {
      title: "招聘工作台",
      layoutStyle: {
        padding: "0px",
        background: "#f0f2f5",
      },
    },
    props: (route) => ({
      ...route.params,
      ...route.query,
    }),
  },
  {
    name: 'candidateRejectReasonList',
    path: "/recruitment/candidateRejectReasonList",
    component: () => import("@/views/recruitment/candidateRejectReason/index"),
    meta: {
      title: '候选人拒绝原因',
    }
  },
  {
    name: 'candidateEliminateReasonList',
    path: "/recruitment/candidateEliminateReasonList",
    component: () => import("@/views/recruitment/candidateEliminateReason/index"),
    meta: {
      title: '候选人淘汰原因',
    }
  },
  {
    name: 'supplierRepeatList',
    path: "/recruitment/supplierRepeatList",
    component: () => import("@/views/recruitment/supplierRepeatList/index"),
    meta: {
      title: '供应商查重信息',
    }
  },
  {
    name: 'matchRuleManagement',
    path: "/recruitment/matchRuleManagement",
    component: () => import("@/views/recruitment/matchRuleManagement/index"),
    meta: {
      title: '简历匹配规则管理',
    }
  }
];
